import {BroadcastLayout, BroadcastType} from '../common/Broadcast';
import {BROADCAST_ITEM_DISPLAY_TYPE} from '@/constants';
import withHiddenStreamer from './withHiddenStreamer';
import ErrorBoundary from '../directory/category/ErrorBoundary';

const VodBroadcastItem = ({
  thumbnailUrl,
  title,
  hasBadge,
  categoryTags,
  hashTags,
  autoHashTags,
  broadcastId,
  duration,
  lastViewDuration,
  vodType,
  createdDate,
  categoryName,
  categoryNo,
  accessibleAge,
  contextMenu,
  handleMenuClicked,
  previewThumbnailUrl,
  userId,
  userNickname,
  originalUserId,
  score,
  originalUserNickname,
  viewCount,
  listDataType,
  location,
  broadcastType,
  log,
  authNumber,
  isPpv,
  vodCategoryNo,
  allowsAdult,
}) => {
  return (
    <ErrorBoundary fallback={<div>로딩중</div>}>
      <BroadcastLayout
        authNumber={authNumber}
        broadcastType={broadcastType}
        viewType={BROADCAST_ITEM_DISPLAY_TYPE.GRID_VIEW}
        thumbnailUrl={thumbnailUrl}
        previewThumbnailUrl={previewThumbnailUrl}
        userId={userId}
        userNickname={userNickname}
        originalUserId={originalUserId}
        originalUserNickname={originalUserNickname}
        viewCount={viewCount}
        title={title}
        hasBadge={hasBadge}
        categoryName={categoryName}
        categoryTags={categoryTags}
        categoryNo={categoryNo}
        vodCategoryNo={vodCategoryNo}
        hashTags={hashTags}
        autoHashTags={autoHashTags}
        broadcastId={broadcastId}
        duration={duration}
        lastViewDuration={lastViewDuration}
        vodType={vodType}
        createdDate={createdDate}
        allowsAdult={allowsAdult}
        accessibleAge={accessibleAge}
        searchActionType='vod'
        contextMenu={contextMenu}
        listDataType={listDataType}
        score={score}
        location={location}
        handleMenuClicked={handleMenuClicked}
        log={log}
        isPpv={isPpv}>
        <BroadcastType.Vod />
      </BroadcastLayout>
    </ErrorBoundary>
  );
};

export default withHiddenStreamer(VodBroadcastItem);
